// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Arrow_wrapper__3Lq26","img":"Arrow_img__2uiRQ","left":"Arrow_left__1z2tz","right":"Arrow_right__1jt-D","show":"Arrow_show__wOMT0","hide":"Arrow_hide__1PzAa"};